import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedLocalPaymentState } from "./shared";

export interface LocalPaymentState extends SharedLocalPaymentState {}

const initialState: LocalPaymentState = {
  ...sharedInitialState,
};

export const localPaymentInfo = createSlice({
  name: "localPaymentInfo",
  initialState,
  reducers: {
    ...sharedReducers,
    // Web-only.
    updateLocalPaymentInfoSlice: (state, action) => {
      return action.payload;
    }
  },
  // Both bodies are empty in the app source — the cases exist but reset nothing.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  updateLocalPaymentInfo,
  updateStrip,
  fetchDeviceConfig,
  fetchDeviceConfigApiResponse,
  updateLocalPaymentInfoSlice
} = localPaymentInfo.actions;
export default localPaymentInfo.reducer;
